export const toMMDDYYYY = (date: Date | undefined) => {
    if (date) {
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
    }
    return ''
}

//takes a js date object and converts it to AM/PM time
export const toUiTime = (date: Date | undefined) => {
    if (date) {
        // the date is today, just need the time to display
        let hours = date.getHours()
        const minutes = date.getMinutes()
        const ampm = hours > 12 ? 'PM' : 'AM'

        hours = hours % 12 //get it out of 24 hr time
        hours = hours ? hours : 12 //if it is 0 instead its 12

        const minuteString = minutes < 10 ? '0' + minutes : minutes // minutes should always have 2 digits
        return `${hours}:${minuteString} ${ampm}`
    }
    return ''
}
